module.exports = require("text-encoding-shim");